import { ChangeEvent } from 'react';
import { Tag } from '@sweep-io/sweep-design';
import { SingleSelectFilterPopoverOption } from '../../common/filters/single-select-filter/SingleSelectFilterPopover';
import { OPTION_ALL } from '../../common/filters/single-select-filter/utils';
import { useUniversalSearchContext } from './UniversalSearchContext';
import { SearchType } from './types';
import { useFeatureToggle } from '../../../feature-flags/useFeatureToggle';
import { SearchInput } from '../building-blocks/search/SearchInput';
import { SearchFilters } from '../building-blocks/search/SearchFilters';

interface UniversalSearchInputProps {
  searchTxt: string;
  tempSearchTxt: string;
  onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onClearButtonClick: () => void;
  filterOptions: SingleSelectFilterPopoverOption[];
  onSelectedFilterItem: (key: string) => void;
  selectedFilterValue?: string;
  isSearchListOpen?: boolean;
  menuOptions?: SingleSelectFilterPopoverOption[];
  selectedMenuOption?: string;
  onSelectMenuOption?: (selectedValue: string) => void;
  isExpandedMode?: boolean;
  searchInputSize?: 'small' | 'default';
  autoFocus?: boolean;
}

export const UniversalSearchInput = ({
  onKeyDown,
  searchTxt,
  tempSearchTxt,
  onChange,
  onClearButtonClick,
  filterOptions,
  menuOptions,
  selectedMenuOption,
  onSelectMenuOption,
  selectedFilterValue = OPTION_ALL.value,
  onSelectedFilterItem,
  isSearchListOpen,
  isExpandedMode,
  searchInputSize = 'small',
  autoFocus,
}: UniversalSearchInputProps) => {
  const { universalSearchRedesign } = useFeatureToggle();
  const { setIsSearchListOpen } = useUniversalSearchContext();
  const isContentSearch = selectedMenuOption === SearchType.content;

  const endAdornment = (
    <>
      {universalSearchRedesign && isContentSearch && onSelectMenuOption && (
        <Tag
          label="By metadata"
          onDelete={() => onSelectMenuOption(SearchType.apiNameAndLabel)}
          size="tiny"
        />
      )}

      {isSearchListOpen && (
        <SearchFilters
          filterOptions={filterOptions}
          selectedFilterValue={selectedFilterValue}
          onSelectedFilterItem={onSelectedFilterItem}
          menuOptions={menuOptions}
          selectedMenuOption={selectedMenuOption}
          onSelectMenuOption={onSelectMenuOption}
        />
      )}
    </>
  );

  return (
    <SearchInput
      searchTxt={searchTxt}
      tempSearchTxt={tempSearchTxt}
      isExpandedMode={!!isExpandedMode}
      onKeyDown={onKeyDown}
      onChange={onChange}
      onClearButtonClick={onClearButtonClick}
      placeholder="Search configurations"
      endAdornment={endAdornment}
      forceCloseButton={!!isSearchListOpen && searchTxt !== ''}
      size={searchInputSize}
      autoFocus={autoFocus}
      onFocus={() => setIsSearchListOpen(true)}
      textFieldSx={{ '& .MuiOutlinedInput-root input': { paddingRight: '4px' } }}
    />
  );
};
